module.exports = __webpack_public_path__ + "img/15.a3c5529f.jpg";